export default __webpack_public_path__ + "static/media/phone1.af698fdb.jpg";